export enum OfflineTaskType {
    Acquisition,
    Reprocessing,
    Cleaning,
    SmartUpdate
}